import toggler from '../lib/toggler.js';

/**
 * Initializes the accordions using toggler
 */
function initAccordion() {
  toggler( '.accordion-item', {
    wrapperSelector: '.accordion-item__wrapper',
    contentSelector: '.accordion-item__content',
    triggerSelector: '.js-toggle-button',
  } );
}

/**
 * Our own accordions
 */
function initZWFAccordions() {
  const accordionToggles = document.querySelectorAll( '.base-lesson-accordion__header' );

  if (!accordionToggles) {
    return;
  }

  [...accordionToggles].forEach( accordionToggle => {
    accordionToggle.addEventListener( 'click', event => {
      event.preventDefault();

      const parentNode = accordionToggle.parentNode;
      const contentHeight = parentNode.classList.contains( 'open' ) ? 0 : parentNode.querySelector( '.base-lesson-accordion__content' )?.clientHeight;
      const contentWrapper = parentNode.querySelector( '.base-lesson-accordion__content-wrapper' );

      parentNode?.classList.toggle( 'open' );
      contentWrapper.style.maxHeight = contentHeight + 'px';
    } );
  } );
}

export default {
  init() {
    initAccordion();
    initZWFAccordions();
  },
};